// Vendor Libraries
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
// Modules
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// NgRx reducers
import { addToWatchlist, ADD_TO_WATCHLIST_STATE_SLICE_KEY, } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.reducer';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AddToWatchlistModalModule {
}
AddToWatchlistModalModule.ɵfac = function AddToWatchlistModalModule_Factory(t) { return new (t || AddToWatchlistModalModule)(); };
AddToWatchlistModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AddToWatchlistModalModule });
AddToWatchlistModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IconModule,
        ModalBaseModule,
        FeatureNeededModule,
        LoadingSymbolModule,
        StoreModule.forFeature(ADD_TO_WATCHLIST_STATE_SLICE_KEY, addToWatchlist),
        TooltipModule] });
